class StringEnumBase {
    constructor(value) {
        this.value = value;
    }
    toString() {
        return this.value;
    }
}
class GeoPropField extends StringEnumBase {
}
GeoPropField.GEOID = new GeoPropField('GEOID');
GeoPropField.NAME = new GeoPropField('NAME');
GeoPropField.ADMIN_DIV_1 = new GeoPropField('ADMIN_DIV_1');
GeoPropField.LATLONG = new GeoPropField('latlng');
GeoPropField.NAME_LONG = new GeoPropField('NAME_LONG');
GeoPropField.NAME_SORT = new GeoPropField('NAME_SORT');
GeoPropField.ADMIN = new GeoPropField('ADMIN');
GeoPropField.FORMAL_EN = new GeoPropField('FORMAL_EN');
GeoPropField.ISO_A3 = new GeoPropField('ISO_A3');
export default GeoPropField;
//# sourceMappingURL=geo-prop-field.js.map